import { alpha, Box, Text, Stack, styled } from '@ltvco/refresh-lib/theme';
import { AttachMoney, Favorite, Search } from '@mui/icons-material';
import { Link } from 'react-router-dom';

import marketplaceIcon from '../../images/marketplace-icon.svg';

export interface MarketplaceProps {
  savedVehiclesCount: number;
  savedSearchesCount: number;
  listedVehiclesCount: number;
}

const MarketplaceCardLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderRadius: `${theme.spacing(0.5)}`,
  boxShadow: `0 0 0 1px ${alpha(theme.palette.button.main, 0.25)}`,
  color: 'inherit',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: `${theme.spacing(1.25)}`,
  textDecoration: 'none',
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest,
  }),
  width: 'calc(25% - 15px)',
  [theme.breakpoints.down('lg')]: {
    width: 'calc(50% - 10px)',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  '&:hover': {
    backgroundColor: theme.palette.background.default,
    '& > :last-child': {
      textDecoration: 'underline',
    },
  },
}));

export const Marketplace = ({
  savedVehiclesCount = 0,
  savedSearchesCount = 0,
  listedVehiclesCount = 0,
}: MarketplaceProps) => {
  const items = [
    {
      name: 'View now',
      icon: <img src={marketplaceIcon} alt="Marketplace Icon" />,
      visibleText: 'Buy a car',
      link: '/marketplace',
    },
    {
      name: 'Sell your car',
      icon: <AttachMoney fontSize="large" sx={{ color: '#212121' }} />,
      visibleText: listedVehiclesCount ? listedVehiclesCount : 'Sell your car',
      link: listedVehiclesCount
        ? '/marketplace/listed-vehicles'
        : '/marketplace/list-your-car',
    },
    {
      name: 'Saved vehicles',
      icon: <Favorite fontSize="large" sx={{ color: '#212121' }} />,
      visibleText: savedVehiclesCount,
      link: '/marketplace/showroom',
    },
    {
      name: 'Saved searches',
      icon: <Search fontSize="large" sx={{ color: '#212121' }} />,
      visibleText: savedSearchesCount,
      link: '/marketplace/saved-searches',
    },
  ];

  return (
    <Box data-testid="marketplace-container">
      <Text variant="h3" mb={2.5} mt={1.5}>
        Marketplace
      </Text>
      <Stack
        flexDirection="row"
        flexWrap="wrap"
        rowGap={1.5}
        display="flex"
        justifyContent="space-between"
      >
        {items.map((item) => (
          <MarketplaceCardLink
            data-testid="marketplace-item"
            to={item.link}
            key={item.name}
          >
            {item.icon}
            <Text variant="h3" mb={2.5} mt={1.5} textAlign="center">
              {item.visibleText}
            </Text>
            <Text
              component="span"
              fontSize="0.875rem"
              textAlign="center"
              width="fit-content"
            >
              {item.name}
            </Text>
          </MarketplaceCardLink>
        ))}
      </Stack>
    </Box>
  );
};
